import { createAction, props, Action } from '@ngrx/store';
import { IAddress } from '@nx-ng/types';
import {
  AddressSearchDrillDownResponse,
  AddressSearchResponse,
} from '../client/src';

// NOTE there is a 'session' string that should be passed if the user is making
// a sequence of requests, to improve accuracy. this is in the store. Not clear
// if it should also be in this action or pulled from the store.
export const SEARCH_ADDRESS_TYPE = '[Address] Search API';
export const addressAPI_search = createAction(
  SEARCH_ADDRESS_TYPE,
  props<{
    searchText: string;
    session?: string;
    requester: string;
  }>()
);

export const addressAPI_searchSuccess = createAction(
  `${SEARCH_ADDRESS_TYPE} Success`,
  props<{ searchResponse: AddressSearchResponse; requester: string }>()
);

export const addressAPI_searchFailure = createAction(
  `${SEARCH_ADDRESS_TYPE} Failure`,
  props<{ error?: string | unknown; requester: string; retryAction?: Action }>()
);

export const DRILLDOWN_ADDRESS_TYPE = '[Address] Search Drill Down API';
export const addressAPI_drillDown = createAction(
  DRILLDOWN_ADDRESS_TYPE,
  props<{ id: string; requester: string }>()
);

export const addressAPI_drillDownSuccess = createAction(
  `${DRILLDOWN_ADDRESS_TYPE} Success`,
  props<{ searchResponse: AddressSearchDrillDownResponse; requester: string }>()
);

export const addressAPI_drillDownFailure = createAction(
  `${DRILLDOWN_ADDRESS_TYPE} Failure`,
  props<{ error?: string | unknown; requester: string; retryAction?: Action }>()
);

export const RETRIEVE_ADDRESS_TYPE = '[Address] Search Retrieve API';
export const addressAPI_retrieve = createAction(
  RETRIEVE_ADDRESS_TYPE,
  props<{ id: string; requester: string; save?: boolean }>()
);

export const addressAPI_retrieveSuccess = createAction(
  `${RETRIEVE_ADDRESS_TYPE} Success`,
  props<{ address: IAddress; requester: string }>()
);

export const addressAPI_retrieveFailure = createAction(
  `${RETRIEVE_ADDRESS_TYPE} Failure`,
  props<{ error?: string | unknown; requester: string; retryAction?: Action }>()
);
